import React, { useEffect, useState } from "react";
import { Breadcrumb, Card, Col, Container, Figure, Row } from "react-bootstrap";
import { sponsors } from "../components/shared/constraints";
import { Link, useNavigate } from "react-router-dom";
import { getUserEventsApi } from "../hooks/ApisContainer/Event";
import useToastContext from "../hooks/useToastContext";
import moment from "moment";
import { BASE_URL } from "../services/path";
import LottiLoader from "../components/shared/Loader/LottiLoader";
import OPagination from "../components/shared/pagination/OPagination";
import NoDataFound from "../components/shared/Loader/NoDataAnimation";
import { textTruncateMore } from "../helper/helper";

const Events = () => {
  const notification = useToastContext();
  const navigate = useNavigate();

  const [event, setEvent] = useState([]);
  const [loader, setLoader] = useState(false);
  const [totalDocs, setTotalDocs] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const fetchedGetEvents = () => {
    const requestPayload = { page: currentPage, pageSize: 12 };
    getUserEventsApi(
      requestPayload,
      notification,
      (loading, error, response) => {
        setLoader(loading);
        if (!error) {
          setEvent(response?.docs);
          setTotalDocs(response?.totalDocs);
        }
      }
    );
  };

  const handlePageChange = async (event) => {
    setCurrentPage(event?.selected + 1);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchedGetEvents();
  }, [currentPage]);
  return (
    <div className="inner-wrapper pb-0">
      <div className="page-title mb-md-5 mb-3">
        <div class="common-heading text-center mb-sm-3 mb-2">
          <h2>Events </h2>
        </div>
        <Breadcrumb>
          <Breadcrumb.Item
            onClick={() => navigate("/")}
            className="text-decoration-none "
          >
            Home
          </Breadcrumb.Item>
          <Breadcrumb.Item active className="text-orange">
            Events
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <section className="all-events-sec mb-md-5 mb-sm-3 mb-2">
        <Container>
          <div class="common-heading text-center mb-md-5 mb-3">
            <h2>
              Our All <span className="text-orange">Events</span>{" "}
            </h2>
          </div>

          <Row className="gx-3">
            {loader ? (
              <Container className="d-flex justify-content-center align-items-center default-back">
                <span>
                  <LottiLoader height={120} width={120} loader={true} />
                </span>
              </Container>
            ) : (
              !loader &&
              event &&
              event.length > 0 &&
              event.map((item) => {
                return (
                  <Col xxl={3} lg={4} md={6} className="mb-4 d-flex">
                    <Card className="sponser-cards speaker-box-layout2 position-relative w-100">
                      <div className="event-date-time position-absolute top-0 bg-black border-white m-2 text-white px-3">
                        <span className="event-date">
                          <i className="bi bi-calendar3 text-white"></i>{" "}
                          {moment(item.date).format("DD MMM YYYY")}
                        </span>
                        <span className="event-time">
                          <i className="bi bi-clock text-white"></i> {item.time}
                        </span>
                      </div>
                      <Figure>
                        <Card.Img
                          variant="top"
                          src={`${BASE_URL}/uploads/${item.headerImage}`}
                          alt="Profile"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src =
                              "https://t4.ftcdn.net/jpg/07/95/29/45/240_F_795294584_LZ4NllndEBSy8vbi37sYngiLIaPdUvtQ.jpg";
                          }}
                        />
                      </Figure>
                      <Card.Body className="text-start d-flex flex-column justify-content-between">
                        <div className="">
                          <Card.Title className="multi-truncate fw-bold fs-6">
                            {item.name}
                          </Card.Title>

                          <Card.Text
                            style={{ color: "gray", fontSize: "14px" }}
                            className="multi-truncate font-bold text-black"
                          >
                            {textTruncateMore(item.description, 70)}
                          </Card.Text>
                          <p className="event-location">
                            <i className="bi bi-geo-alt"></i>{" "}
                            {item.address.length > 28
                              ? item.address.slice(0, 28) + "..."
                              : item.address}
                          </p>
                        </div>
                        <Link
                          to={`/events/${item._id}`}
                          className="border read-more fs-13 max-width-content text-decoration-none bg-orange text-white d-inline-block p-1 px-2"
                        >
                          Read More <i className=" ms-1 bi bi-arrow-right"></i>
                        </Link>
                      </Card.Body>
                    </Card>
                  </Col>
                );
              })
            )}
            {!loader && event?.length == 0 && (
              <NoDataFound
                height={200}
                width={200}
                firstMessage="No Events there."
              />
            )}
            {!loader && event && event?.length > 0 && (
              <div className="d-flex justify-content-center">
                <OPagination
                  pageCount={Math.ceil(totalDocs / 10)}
                  handlePageClick={(e) => handlePageChange(e)}
                  page={currentPage}
                />
              </div>
            )}
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Events;
